type GtmEvent = { event: string; [key: string]: any };

export const pushEvent = (payload: GtmEvent) => {
  if (typeof window === "undefined") return;
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(payload);
};
